<template>
  <div id="app" ref="appRef">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="isRouterAlive || !$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: false,
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.setupContextMenu();
    });
  },
  beforeDestroy() {
    this.removeContextMenuListener();
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
    setupContextMenu() {
      const isPC = !/Mobi|Android|Silk\/|Kindle|BlackBerry|Opera Mini|IEMobile|Mobile|Tablet/i.test(navigator.userAgent);
      if (isPC) {
        // 如果是PC，则添加contextmenu.prevent事件监听器
        this.$refs.appRef.addEventListener('contextmenu', this.preventDefault);
      }
    },
    // 移除之前添加的contextmenu事件监听器
    removeContextMenuListener() {
      this.$refs.appRef.removeEventListener('contextmenu', this.preventDefault);
    },
    preventDefault(event) {
      // 阻止默认的右键菜单行为
      // event.preventDefault();
    }
  },
};
</script>


<style>
.user-popper{
  padding: 0 !important;
}
.el-message{
  max-width: 70%;
  min-width: 500rem !important;
}
.el-message-box {
  max-width: 70%;
}
</style>